import { ApidaeGridItem } from './apidaeListAPI';
import { isApidaeEventType } from './apidaeEventDates';

export type ApidaeGridSortMode = 'openingDate' | 'city' | 'title';

/** Clé de tri pour les fiches sans date (placées en fin de liste). */
const NO_DATE_SORT_KEY = '9999-99-99';

function imageScore(item: ApidaeGridItem): number {
  return item.urlimg ? 1 : 0;
}

function compareByImage(a: ApidaeGridItem, b: ApidaeGridItem): number {
  return imageScore(b) - imageScore(a);
}

function compareByTitle(a: ApidaeGridItem, b: ApidaeGridItem): number {
  return (a.storeName || '').localeCompare(b.storeName || '', 'fr', { sensitivity: 'base' });
}

function compareByCity(a: ApidaeGridItem, b: ApidaeGridItem): number {
  const cityCmp = (a.city || '').localeCompare(b.city || '', 'fr', { sensitivity: 'base' });
  return cityCmp !== 0 ? cityCmp : compareByTitle(a, b);
}

function compareByOpeningDate(a: ApidaeGridItem, b: ApidaeGridItem): number {
  const aDate = a.eventPeriod?.dateDebut ?? NO_DATE_SORT_KEY;
  const bDate = b.eventPeriod?.dateDebut ?? NO_DATE_SORT_KEY;
  if (aDate !== bDate) return aDate.localeCompare(bDate);
  return compareByTitle(a, b);
}

/**
 * Tri par défaut si aucun réglage Sanity : date pour les événements (types agenda),
 * titre pour les autres. Fiches sans date en fin de liste.
 */
function compareAutoDefault(a: ApidaeGridItem, b: ApidaeGridItem): number {
  const aEvent = isApidaeEventType(a.apidaeType);
  const bEvent = isApidaeEventType(b.apidaeType);
  const aHasDate = !!a.eventPeriod?.dateDebut;
  const bHasDate = !!b.eventPeriod?.dateDebut;

  if (aEvent && aHasDate && !(bEvent && bHasDate)) return -1;
  if (bEvent && bHasDate && !(aEvent && aHasDate)) return 1;

  if (aEvent && bEvent && aHasDate && bHasDate) {
    return compareByOpeningDate(a, b);
  }

  return compareByTitle(a, b);
}

export function sortApidaeGridItems(
  items: ApidaeGridItem[],
  sortMode?: ApidaeGridSortMode | null
): ApidaeGridItem[] {
  return [...items].sort((a, b) => {
    const byImage = compareByImage(a, b);
    if (byImage !== 0) return byImage;

    switch (sortMode) {
      case 'openingDate':
        return compareByOpeningDate(a, b);
      case 'city':
        return compareByCity(a, b);
      case 'title':
        return compareByTitle(a, b);
      default:
        return compareAutoDefault(a, b);
    }
  });
}
